import React from 'react';
import { Home, Grid3X3, Clock, TrendingUp, BookOpen } from 'lucide-react';

const BottomNav = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'home', icon: Home, label: 'Home' },
    { id: 'categories', icon: Grid3X3, label: 'Category' },
    { id: 'terbaru', icon: Clock, label: 'Terbaru' },
    { id: 'trending', icon: TrendingUp, label: 'Trending' },
    { id: 'cerita', icon: BookOpen, label: 'Cerita' },
  ];

  return (
    <nav className="bottom-nav">
      {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            className={`bottom-nav-item ${isActive ? 'active' : ''}`}
            onClick={() => onTabChange && onTabChange(tab.id)}
          >
            <div className={`bottom-nav-icon ${isActive ? 'active' : ''}`}>
              <Icon size={20} />
            </div>
            <span className="bottom-nav-label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
